/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionPlanTimeEntryDto
 */
export interface ExecutionPlanTimeEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTimeEntryDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTimeEntryDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTimeEntryDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTimeEntryDto
     */
    taskId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTimeEntryDto
     */
    userId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTimeEntryDto
     */
    loggedDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTimeEntryDto
     */
    hours?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTimeEntryDto
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTimeEntryDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTimeEntryDto
     */
    createdBy?: string;
}

/**
 * Check if a given object implements the ExecutionPlanTimeEntryDto interface.
 */
export function instanceOfExecutionPlanTimeEntryDto(value: object): value is ExecutionPlanTimeEntryDto {
    return true;
}

export function ExecutionPlanTimeEntryDtoFromJSON(json: any): ExecutionPlanTimeEntryDto {
    return ExecutionPlanTimeEntryDtoFromJSONTyped(json, false);
}

export function ExecutionPlanTimeEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanTimeEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'loggedDate': json['loggedDate'] == null ? undefined : (new Date(json['loggedDate'])),
        'hours': json['hours'] == null ? undefined : json['hours'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function ExecutionPlanTimeEntryDtoToJSON(json: any): ExecutionPlanTimeEntryDto {
    return ExecutionPlanTimeEntryDtoToJSONTyped(json, false);
}

export function ExecutionPlanTimeEntryDtoToJSONTyped(value?: ExecutionPlanTimeEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'planId': value['planId'],
        'taskId': value['taskId'],
        'userId': value['userId'],
        'loggedDate': value['loggedDate'] == null ? undefined : ((value['loggedDate']).toISOString().substring(0,10)),
        'hours': value['hours'],
        'notes': value['notes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'createdBy': value['createdBy'],
    };
}

